import React from 'react';
import { Lock, ArrowRight } from 'lucide-react';

const InternetSubesi = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <div className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.02) 35px, rgba(255,255,255,.02) 70px)'
            }}></div>
          </div>
        </div>

        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="bg-orange-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8">
            <Lock className="w-10 h-10 text-orange-600" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">İnternet Şubesi</h1>
          <p className="text-slate-300 text-xl mb-8 max-w-2xl mx-auto">
            Yatırımlarınızı dijital platformumuz üzerinden güvenle yönetin
          </p>
          
          <div className="space-y-4 max-w-md mx-auto">
            <a
              href="https://my.scuzdan.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 rounded-lg font-semibold hover:shadow-lg hover:shadow-orange-500/50 transition-shadow"
            >
              <span className="flex items-center justify-center space-x-2">
                <span>Giriş Yap</span>
                <ArrowRight className="w-5 h-5" />
              </span>
            </a>
            
            <a
              href="https://my.scuzdan.com/register"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full border-2 border-white/30 text-white py-4 rounded-lg font-semibold hover:bg-white/10 transition-all"
            >
              Yeni Üyelik
            </a>
          </div>

          <div className="mt-12">
            <p className="text-slate-400 text-sm mb-4">Yardıma mı ihtiyacınız var?</p>
            <a
              href="/iletisim"
              className="inline-flex items-center space-x-2 text-orange-400 hover:text-orange-300 font-semibold transition-colors"
            >
              <span>Bizimle İletişime Geçin</span>
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternetSubesi;